import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_badge = _resolveComponent("q-badge")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.badgeOptions, (item, index) => {
    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
      (item.show)
        ? (_openBlock(), _createBlock(_component_q_badge, {
            key: 0,
            style: {"min-height":"20px"},
            color: "primary",
            rounded: "",
            floating: _ctx.floating,
            class: _normalizeClass(_ctx.contentClass)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tooltip, { "content-class": "s-tooltip" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.tooltip), 1)
                ]),
                _: 2
              }, 1024),
              _createElementVNode("span", null, _toDisplayString(item.title), 1)
            ]),
            _: 2
          }, 1032, ["floating", "class"]))
        : _createCommentVNode("", true)
    ], 64))
  }), 128))
}